import * as React from "react"

const SIZE_CLASSES = {
  sm: "w-10 h-10",
  md: "w-14 h-14",
  lg: "w-28 h-28",
}

const PLACEHOLDER_TEXT_CLASSES = {
  sm: "text-[6px]",
  md: "text-[9px]",
  lg: "text-xs",
}

// alt fica disponível pro <img>/aria-label mesmo quando não há foto,
// pra manter o contexto de quem é o avatar em telas de leitor de tela.
export default function Avatar({ src, alt, size = "md", expandable = false }) {
  const [expanded, setExpanded] = React.useState(false)
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md
  const textClass =
    PLACEHOLDER_TEXT_CLASSES[size] || PLACEHOLDER_TEXT_CLASSES.md
  const canExpand = expandable && Boolean(src)

  // Fecha com Escape, igual aos outros modais do app
  React.useEffect(() => {
    if (!expanded) return
    function onKey(e) {
      if (e.key === "Escape") setExpanded(false)
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [expanded])

  function handleBackdropClick(e) {
    if (e.target === e.currentTarget) setExpanded(false)
  }

  const avatarNode = !src ? (
    <div
      className={`${sizeClass} shrink-0 rounded-full bg-slate-300 border-2 border-slate-200 flex items-center justify-center overflow-hidden`}>
      <span
        className={`${textClass} text-slate-500 font-semibold leading-tight text-center px-1`}>
        Sem foto de perfil
      </span>
    </div>
  ) : (
    <img
      src={src}
      alt={alt || "Foto de perfil"}
      className={`${sizeClass} shrink-0 rounded-full object-cover border-2 border-cor-base/40 bg-slate-100 ${
        canExpand ? "cursor-pointer hover:scale-[1.05] transition-all" : ""
      }`}
    />
  )

  return (
    <>
      {canExpand ? (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          aria-label={`Ver foto de ${alt || "perfil"} ampliada`}
          className="rounded-full focus:outline-none focus:ring-2 focus:ring-cor-base focus:ring-offset-2">
          {avatarNode}
        </button>
      ) : (
        avatarNode
      )}

      {expanded && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 rounded-2xl"
          onClick={handleBackdropClick}>
          <div className="relative flex flex-col items-center gap-4">
            <button
              onClick={() => setExpanded(false)}
              className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-white text-slate-700 text-xl leading-none flex items-center justify-center shadow-lg hover:scale-105 transition-all"
              aria-label="Fechar"
              type="button">
              ×
            </button>
            <img
              src={src}
              alt={alt || "Foto de perfil"}
              className="max-w-[80vw] max-h-[80vh] w-72 h-72 sm:w-96 sm:h-96 object-cover rounded-2xl border-4 border-white shadow-2xl"
            />
            {alt && (
              <p className="text-slate-100 font-semibold text-center">{alt}</p>
            )}
          </div>
        </div>
      )}
    </>
  )
}
